import { Injectable } from '@angular/core'

import { EmployeeContract } from './employee-contract'

@Injectable()
export class EmployeeContractSerializer {
  fromJson(json: any): EmployeeContract {
    const employeeContract = {
      ...json
    }

    return employeeContract
  }

  toJson(employeeContract: EmployeeContract): any {
    return {
      ...employeeContract
    }
  }
}
